import { render, staticRenderFns } from "./post.vue?vue&type=template&id=e07a3ee0&scoped=true&"
import script from "./post.vue?vue&type=script&lang=js&"
export * from "./post.vue?vue&type=script&lang=js&"
import style0 from "./post.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./post.vue?vue&type=style&index=1&id=e07a3ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07a3ee0",
  null
  
)

export default component.exports